<!-- eslint-disable -->
<template lang="pug">
    .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
        label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}
        .form__field-body
            cs-multiselect(
                :options="bpmValues"
                :value="metronomeSpeed"
                :custom-label="formatBPM"
                :placeholder="formatBPM(metronomeSpeed)"
                @input="$emit('updateSpeed', $event)"
                :multiple="false"
                :allow-empty="false"
            )
</template>

<script>
    /*eslint-disable*/
import IntervalConfig from '../trainer/configs/IntervalConfig'

export default {
    props: {
        gameMode: {
            type: String,
            default: 'homework'
        },
        metronomeSpeed: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            bpmValues: IntervalConfig.bpmValues
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.query.slug === 'Shutter';
        }
    },
    methods: {
        formatBPM(amount) {
            return amount
                ? `${amount} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_bpm')
                : this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
        }
    },
}
</script>

<style lang="scss" scoped>
    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }
    .form__field-body {
        flex-grow: 5;
    }
</style>
